import { MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Select, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';


const KPIColorSetter = ({
    form,
    showBorder,
    name,
    initValue,
    defaultValue
}) => {
    const [rowCount, setRowCount] = useState(1);
    useEffect(() => {
        console.log(initValue, defaultValue);
        if(defaultValue){
            console.log('in progress');
        }
        if(initValue){
            form.setFieldsValue({ [`${name}-min`]: initValue.min.toString() });
            form.setFieldsValue({ [`${name}-from-1`]: initValue.min.toString() });
            form.setFieldsValue({ [`${name}-to-1`]: initValue.max.toString() });
            form.setFieldsValue({ [`${name}-max`]: initValue.max.toString() });
            form.setFieldsValue({ [`${name}-min-colr`]: initValue.minColr });
            form.setFieldsValue({ [`${name}-colr-1`]: initValue.firstRowColr });
            form.setFieldsValue({ [`${name}-max-colr`]: initValue.maxColr });
            form.setFieldsValue({ [`${name}-isVirgin`]: true });
        }
        // form.setFieldsValue({ [`${name}-from-1`]: 0 })
    }, []);


    useEffect(() => {
        form.setFieldsValue({ [`${name}-rowCount`]: rowCount })
    }, [rowCount])

    const addNew = () => {
        let lastToVal = form.getFieldsValue()[`${name}-to-${rowCount}`];
        let lastFromVal = form.getFieldsValue()[`${name}-from-${rowCount}`];
        if(!lastToVal){
            return alert('Please Enter greater value')
        }
        if (parseFloat(lastToVal) < parseFloat(lastFromVal)) {
            return alert('Your greater than value is less than lesser than value')
        }
        form.setFieldsValue({ [`${name}-from-${rowCount + 1}`]: lastToVal });
        setRowCount(rowCount + 1);
    }

    const onInitialValueChange = (e) => {
        form.setFieldsValue({ [`${name}-from-1`]: e.target.value })
    }

    const deleteRow = () => {
        let lastVal = form.getFieldsValue()[`${name}-to-${rowCount - 1}`];
        console.log(lastVal);
        form.setFieldsValue({ [`${name}-from-${rowCount}`]: null });
        form.setFieldsValue({ [`${name}-to-${rowCount}`]: null });
        form.setFieldsValue({ [`${name}-max`]: lastVal });
        setRowCount(rowCount - 1);
    }

    return (
        <div className={showBorder ? 'kpi-color-setter-bordered': 'kpi-color-setter-no-bordered'}>
            <Form.Item hidden name={`${name}-rowCount`} />
            <Row style={{marginBottom: 10}}>
                <Col span={7} className='ant-form-item-label' style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                    <label className='ant-form-item' title={"Less Than"}>Less Than</label>
                </Col>
                <Col span={7} className='ant-form-item-label' style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                    <label className='ant-form-item' title={'Greater Than'}>Greater Than</label>
                </Col>
                <Col span={7} className='ant-form-item-label' style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                    <label className='ant-form-item' title={'Color'}>Color</label>
                </Col>
            </Row>
            <Row>
                <Col span={7}>
                    <Form.Item initialValue={"less than"}>
                        <Input type='text' value="less than" disabled />
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item name={`${name}-min`} rules={[{ required: true, message: 'This field is required' }]}>
                        <Input disabled={rowCount > 1} type="number" onChange={onInitialValueChange} step={".01"} />
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item name={`${name}-min-colr`} rules={[{ required: true, message: 'Please select Color' }]}>
                        <Select
                            placeholder="Select Color"
                            options={[
                                { label: 'Green', value: 'green' },
                                { label: 'Orange', value: 'orange' },
                                { label: 'Yellow', value: 'yellow' },
                                { label: 'Red', value: 'red' },
                                { label: 'Blue', value: 'blue' },
                            ]} />
                    </Form.Item>
                </Col>
            </Row>
            {
                Array.from({ length: rowCount }).map((_, index) => (
                    <Row>
                        <Col span={7}>
                            <Form.Item name={`${name}-from-${index + 1}`} rules={[{ required: true, message: 'This field is required' }]}>
                                <Input type="number" disabled step={".01"} />
                            </Form.Item>
                        </Col>
                        <Col span={7}>
                            <Form.Item
                                name={`${name}-to-${index + 1}`}
                                rules={[{
                                    required: true, message: 'This is required',
                                },
                                // {
                                //     min: (parseFloat(form.getFieldsValue()[`${name}-from-${index + 1}`]))
                                // }
                                ]}
                            >
                                <Input step={".01"} disabled={(index + 1) < rowCount} type="number" placeholder='Enter Number' onChange={(e) => {
                                    if ((index + 1) === rowCount) {
                                        form.setFieldsValue({ [`${name}-max`]: e.target.value });
                                    } else {
                                        // if(parseInt(rowCount) > 1){
                                        //     form.setFieldsValue({ [`${name}-from-${(index + 1) + 1}`]: e.target.value });
                                        // }
                                    }
                                }} />
                            </Form.Item>
                        </Col>
                        <Col span={7}>
                            <Form.Item name={`${name}-colr-${index + 1}`} rules={[{ required: true, message: 'Please Select Color' }]}>
                                <Select
                                    placeholder="Select Color"
                                    options={[
                                        { label: 'Green', value: 'green' },
                                        { label: 'Orange', value: 'orange' },
                                        { label: 'Yellow', value: 'yellow' },
                                        { label: 'Red', value: 'red' },
                                        { label: 'Blue', value: 'blue' },

                                    ]} />
                            </Form.Item>
                        </Col>
                        {
                            ((index + 1) === parseInt(rowCount)) && (
                                <Col span={3} style={{display: 'inline-flex'}}>
                                    <Tooltip title="Add New" color="green">
                                        <Button
                                            className='add-new-icon'
                                            icon={<PlusCircleFilled />}
                                            type="link" onClick={addNew}>{''}</Button>
                                    </Tooltip>
                                    {
                                        parseInt(rowCount) > 1 && (
                                            <Tooltip title="Delete" color="red">
                                                <Button
                                                    className='delete-row-icon'
                                                    icon={<MinusCircleFilled />}
                                                    type="link" onClick={deleteRow}>{''}</Button>
                                            </Tooltip>
                                        )
                                    }
                                </Col>
                            )
                        }
                    </Row>
                ))
            }
            <Row>
                <Col span={7}>
                    <Form.Item name={`${name}-max`} rules={[{
                        required: true,
                        message: 'This field is required'
                    }]}>
                        <Input disabled type="number" step={".01"} />
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item initialValue={"greater than"} rules={[{
                        required: true,
                        message: 'This field is required'
                    }]}>
                        <Input type='text' value="greater than" disabled />
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item name={`${name}-max-colr`} rules={[{ required: true, message: 'Please Select Color' }]}>
                        <Select
                            placeholder="Select Color"
                            options={[
                                { label: 'Green', value: 'green' },
                                { label: 'Orange', value: 'orange' },
                                { label: 'Yellow', value: 'yellow' },
                                { label: 'Red', value: 'red' },
                                { label: 'Blue', value: 'blue' },
                            ]} />
                    </Form.Item>
                </Col>
            </Row>
        </div>
    )
};

export default KPIColorSetter;